
import Cookies from "js-cookie";


export function clearCookies() {
    window.localStorage.clear();
    Cookies.remove("psg_auth_token");
    Cookies.remove("arpari_user_auth_token");
    Cookies.remove("messages");
    Cookies.remove("csrftoken");
    Cookies.remove("sessionid");
    Cookies.remove("sessionid", { path: "/" });
}
